class CampaignList {
	constructor(activeCampaigns, placeholderImageURL) {
		this.activeCampaigns = activeCampaigns;
		this.placeholderImageURL = placeholderImageURL;
	}
	renderCampaigns() {
		this.activeCampaigns.forEach(campaign => {
			if (campaign.id != 410722) {
				$(".swell-campaign-list").append(
					$("<li>").addClass("campaign").append(
						$("<div>").append(
							$("<i>").addClass(campaign.icon),
							$("<h5>", {
								text: campaign.title
							})
						).attr('id', `campaign-${campaign.id}`),
					));
					if (campaign.rewardText != "") {
						$(`#campaign-${campaign.id}`).append(
							$("<button>", {
								text: campaign.rewardText
							}).addClass("swell-campaign-link").attr({
								"data-campaign-id": campaign.id,
								"data-display-mode": "modal"
							}).addClass("pink")
						)
					};
			}
		});
		$(".swell-campaign-list").append(
			$("<li>").addClass("fillerImage").append(
				$("<img>", {
					src: this.placeholderImageURL
				})
			)
		)
	}

	static renderLoginPrompt(isCustomerMember) {
		isCustomerMember ? "" : $("<div>").addClass("swell-login-prompt").append(
			$("<div>").css("width", "40%").append(
				$("<button>").text("LOGIN").addClass("pink-button").css({"padding": "0.5rem 3.2rem", "width": "10rem", "cursor": "pointer"}).click(() => window.location.href = "../account/login"),
				$("<button>").text("SIGN UP").addClass("swell-campaign-link").addClass("pink").css({"width": "10rem", "cursor": "pointer"}).click(() => window.location.href = "../account/register")
			)
		).appendTo(".campaign");
	}

}

